export const EXPORT_FORMATS = [
  { id: "pdf", label: "PDF", extension: ".pdf", mimeType: "application/pdf" },
  { id: "docx", label: "Word Document", extension: ".docx", mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" },
  { id: "json", label: "JSON", extension: ".json", mimeType: "application/json" },
  { id: "csv", label: "CSV", extension: ".csv", mimeType: "text/csv" },
  { id: "txt", label: "Plain Text", extension: ".txt", mimeType: "text/plain" },
] as const;

export type ExportFormat = typeof EXPORT_FORMATS[number]["id"];

export function getFormatById(id: string) {
  return EXPORT_FORMATS.find(f => f.id === id) || EXPORT_FORMATS[0];
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function generateFilename(prefix: string, ext: string) {
  return `${prefix}_${new Date().toISOString().replace(/[:.]/g, "-")}${ext}`;
}

export function exportBatchResultsAsCSV(rows: any[]): string {
  if (!rows.length) return "";
  const keys = Object.keys(rows[0]);
  const header = keys.join(",");
  const body = rows.map(r => keys.map(k => JSON.stringify(r[k] ?? "")).join(",")).join("\n");
  return header + "\n" + body;
}

export function generateProvenanceHTML(data: any): string {
  const rows = Array.isArray(data) ? data : [data];
  const html = rows.map((r: any) => `<div class="provenance-entry"><pre>${JSON.stringify(r, null, 2)}</pre></div>`).join("\n");
  return `<!DOCTYPE html><html><head><title>Provenance Audit</title><style>body{font-family:monospace;background:#111;color:#e2e8f0;padding:2rem}.provenance-entry{margin:1rem 0;padding:1rem;border:1px solid #333;border-radius:4px}pre{white-space:pre-wrap}</style></head><body><h1>Provenance Audit Report</h1>${html}</body></html>`;
}
